import React from "react";
import "./common.css";

import Logo from "../images/logo.svg";
import Insta from "../images/insta.svg";
import Linked from "../images/linkedin.svg";
import Fb from "../images/fb.svg";
import Twitter from "../images/twitter.svg";

// width: 60%
//   width:75%

function Footer({footerWidth}) {
  return (
    <>
      <div className="footer_container">
        <div className="footer_content" style={{width:footerWidth}}>
          <div className="section_one">
            <h4>
              <b>COMPANY</b>
            </h4>
            <p>About us</p>
            <p>Team</p>
            <p>Help & Support</p>
            <p>Ride with us</p>
            <p>Partner with us</p>
          </div>
          <div className="section_two">
            <img src={Logo} alt="logoImg" />
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard Lorem Ipsum
              is simply dummy text{" "}
            </p>
            <div className="email_input_div">
              <input
                style={{
                  border: "1px solid #8895A7",
                  borderRight: "none",
                  borderRadius: "5px",
                  borderTopRightRadius: "0px",
                  borderBottomRightRadius: "0px",
                }}
                className="email_input"
                type="text"
                placeholder="Enter email Address"
                name="location"
              />
              <button className="email_btn" type="submit">
                Subscribe
              </button>
            </div>
          </div>
          <div className="section_three">
            <h4>
              <b>LEGAL</b>
            </h4>
            <p>Term & Condition</p>
            <p>Refund & Cancellation</p>
            <p>Privacy Policy</p>
            <p>Cookie Policy</p>
            <p>Offer Term</p>
          </div>
        </div>
      </div>
      <div className="footer_divider"></div>
      <div className="social_footer_container">
        <div className="social_footer" style={{width:footerWidth}}>
          <div className="social_text">
            Copyright © 2021 Barnaslunsj Pvt. Ltd. All rights reserved.
          </div>
          <div className="social_icons">
            <img src={Fb} alt="icons" />
            <img src={Twitter} alt="icons" />
            <img src={Linked} alt="icons" />
            <img src={Insta} alt="icons" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
